import React, { createContext, useState, useCallback } from 'react';

export const ProfileContext = createContext();

export const ProfileContextProvider = ({ children }) => {
  const [profileRefresh, setProfileRefresh] = useState(0);

  const triggerProfileRefresh = useCallback(() => {
    setProfileRefresh((prev) => prev + 1);
  }, []);

  return (
    <ProfileContext.Provider value={{ profileRefresh, triggerProfileRefresh }}>
      {children}
    </ProfileContext.Provider>
  );
};
